module.exports = __webpack_public_path__ + "img/consult_info3.252211e0.png";